import React, { Component } from 'react';
import { Redirect } from 'react-router';

class ConfirmOrder extends Component {
  


  render() {
      return (<Redirect to ="/" />);
    }
}

export default ConfirmOrder;
